<template>
    <div class="col-12 px-0 mx-0">
        <b-col md="12" class="px-0 col-12">
            <b-row>
                <b-container fluid v-for="(data) of tableData" :key="data.uuid" >
                    <b-card class="mb-3 shadow-lg border border-light">
                        <b-card-body class="py-2 px-2">
                            <b-col class="px-0">
                                <b-row>
                                    <b-col md="12" class="px-0 mx-0">
                                        <b-row class="d-flex justify-content-between align-items-center">
                                            <b-col class="col-auto">
                                                <p class="h6 mb-0 font-weight-bold">{{ data.name }}</p>
                                            </b-col>
                                            <b-col>
                                                <b-badge pill :variant="data?.status.uuid !== '58380ab4-67a4-40ee-9860-7d5ba78f965f' ? 'primary' : 'warning'" class="mr-1">
                                                    {{ data?.status.name }}
                                                </b-badge>
                                                <b-badge pill :variant="getVariant(data.expiredDate)">
                                                    {{ data.expiredDate }}
                                                </b-badge>
                                            </b-col>
                                            <b-col class="col-auto mr-3">
                                                <b-row>
                                                    <b-form-checkbox @change="editStatus(data)"
                                                        :disabled="updateStatusPermission == false"
                                                        v-model="data.isActive" switch class="mt-1">
                                                    </b-form-checkbox>
                                                    <a style="padding-right: 10px;" href="javascript:void(0);" :class="currentUser == data.email
                                                        ? 'disabled text-warning'
                                                        : 'text-primary'
                                                        " @click="toReportDetailsPage(data?.uuid)" v-b-tooltip.hover
                                                        v-if="readPermission == true && updatePermission == true" title="Detail">
                                                        <i class="mdi mdi-file-document-outline font-size-18"></i>
                                                    </a>

                                                    <a href="javascript:void(0);" :class="currentUser == data.email
                                                        ? 'disabled text-warning'
                                                        : 'text-primary'
                                                        " @click="toDetailsPage(data?.uuid)" v-b-tooltip.hover
                                                        v-if="readPermission == true && updatePermission == true" title="Edit">
                                                        <i class="mdi mdi-pencil font-size-18"></i>
                                                    </a>

                                                    <a href="javascript:void(0);" :class="currentUser == data.email
                                                        ? 'disabled text-warning'
                                                        : 'text-primary'
                                                        " @click="toDetailsPage(data?.uuid)" v-b-tooltip.hover
                                                        style="margin-left: 5px;"
                                                        v-if="readPermission == true && updatePermission != true" title="Read">
                                                        <i class="mdi mdi-file-search-outline font-size-18"></i>
                                                    </a>
                                                </b-row>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-2 px-0">
                                    <b-col md="2" class="px-1 border">
                                        <div class="text-center">
                                            <small class="font-weight-bold text-muted">{{ $t('module.company') }}</small>
                                            <h6 class="mt-1 mb-0 text-truncate">{{ data.brand }}</h6>
                                        </div>
                                    </b-col>
                                    <b-col md="2" class="px-1 border">
                                        <div class="text-center">
                                            <small class="font-weight-bold text-muted">{{ $t('module.form') }}</small>
                                            <h6 class="mt-1 mb-0 text-truncate">{{ data.form }}</h6>
                                        </div>
                                    </b-col>
                                    <b-col md="2" class="px-1 border">
                                        <div class="text-center">
                                            <small class="font-weight-bold text-muted">{{ $t('module.type') }}</small>
                                            <h6 class="mt-1 mb-0 text-truncate">{{ data.type }}</h6>
                                        </div>
                                    </b-col>
                                    <b-col md="2" class="px-1 border">
                                        <div class="text-center">
                                            <small class="font-weight-bold text-muted">{{ $t('module.class') }}</small>
                                            <h6 class="mt-1 mb-0 text-truncate">{{ data.class }}</h6>
                                        </div>
                                    </b-col>
                                    <b-col md="2" class="px-1 border">
                                        <div class="text-center">
                                            <small class="font-weight-bold text-muted">{{ $t('label.lrmp') }}</small>
                                            <h6 class="mt-1 mb-0 text-truncate">{{ data.lrmp }}</h6>
                                        </div>
                                    </b-col>
                                    <b-col md="2" class="px-1 border">
                                        <div class="text-center">
                                            <small class="font-weight-bold text-muted">{{ $t('label.XreferenceNumber', []) }}</small>
                                            <h6 class="mt-1 mb-0 text-truncate">{{ data.referenceNumber }}</h6>
                                        </div>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-0">
                                    <b-col md="4" class="px-0 mb-1">
                                        <b-list-group class="py-0">
                                            <b-list-group-item class="py-0 d-flex justify-content-between align-items-center px-2">
                                                <p class="text-muted font-weight-bold font-size-16 my-0">{{ $t('label.dor') }}</p>
                                                <p class="font-size-16 my-0">{{ data.dor }}</p>
                                            </b-list-group-item>
                                            <b-list-group-item class="py-0 d-flex justify-content-between align-items-center px-2">
                                                <p class="text-muted font-weight-bold font-size-16 my-0">{{ $t('label.dorSubmissionDate') }}</p>
                                                <p class="font-size-16 my-0">{{ data.dossierSubmissionDate }}</p>
                                            </b-list-group-item>
                                            <b-list-group-item class="py-0 d-flex justify-content-between align-items-center px-2">
                                                <p class="text-muted font-weight-bold font-size-16 my-0">{{ $t('label.approvalDate') }}</p>
                                                <p class="font-size-16 my-0">{{ data.approvalDate }}</p>
                                            </b-list-group-item>
                                        </b-list-group>
                                    </b-col>
                                    <b-col md="4" class="px-1 mb-1">
                                        <b-list-group class="py-0">
                                            <b-list-group-item class="py-0 my-0 d-flex justify-content-between align-items-center px-2">
                                                <p class="text-muted font-weight-bold font-size-16 my-0">{{ $t('label.purpose') }}</p>
                                                <p class="font-size-16 my-0">{{ data.purpose }}</p>
                                            </b-list-group-item>
                                            <b-list-group-item class="py-0 d-flex justify-content-between align-items-center px-2">
                                                <p class="text-muted font-weight-bold font-size-16 my-0">{{ $t('label.isRegisterCert') }}</p>
                                                <p class="font-size-16 my-0">{{ data.isRegisterCert }}</p>
                                            </b-list-group-item>
                                            <b-list-group-item class="py-0 d-flex justify-content-between align-items-center px-2">
                                                <p class="text-muted font-weight-bold font-size-16 my-0">{{ $t('label.shelfLifeTime') }}</p>
                                                <p class="font-size-16 my-0">{{ data.shelfLifeTime }}</p>
                                            </b-list-group-item>
                                        </b-list-group>
                                    </b-col>
                                    <b-col md="4" class="px-0 mb-1">
                                        <b-list-group class="py-0">
                                            <b-list-group-item class="py-0 d-flex justify-content-between align-items-center px-2">
                                                <p class="text-muted font-weight-bold font-size-16 my-0">{{ $t('module.query') }}</p>
                                                <p class="font-size-16 my-0">{{ data.productQuery }}</p>
                                            </b-list-group-item>
                                            <b-list-group-item class="py-0 d-flex justify-content-between align-items-center px-2">
                                                <p class="text-muted font-weight-bold font-size-16 my-0">{{ $t('module.productPayment') }}</p>
                                                <p class="font-size-16 my-0">{{ data.productPayment }}</p>
                                            </b-list-group-item>
                                            <b-list-group-item class="py-0 d-flex justify-content-between align-items-center px-2">
                                                <p class="text-muted font-weight-bold font-size-16 my-0">{{ $t('module.productPrinterProof') }}</p>
                                                <p class="font-size-16 my-0">{{ data.productPrinterProof }}</p>
                                            </b-list-group-item>
                                        </b-list-group>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col md="12" class="px-0 table-responsive">
                                        <table class="table-bordered w-100">
                                            <tbody>
                                                <tr>
                                                    <td class="col-3 text-nowrap">
                                                        <p class="text-muted font-weight-bold font-size-16 my-0">{{ $t('label.endorseLabel') }}</p>
                                                    </td>
                                                    <td class="text-nowrap">
                                                        <b-badge
                                                            v-for="(item, index) of data.endorseLabelArray"
                                                            :key="index"
                                                            variant="info"
                                                            class="ml-1"
                                                        >
                                                            <p class="font-size-16 my-0">{{ item }}</p>
                                                        </b-badge>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="col-3 text-nowrap">
                                                        <p class="text-muted font-weight-bold font-size-16 my-0">{{ $t('module.productAI') }}</p>
                                                    </td>
                                                    <td class="text-nowrap">
                                                        <b-badge
                                                            v-for="(item, index) of data.productAI"
                                                            :key="index"
                                                            variant="info"
                                                            class="ml-1"
                                                        >
                                                            <p class="font-size-16 my-0">{{ item }}</p>
                                                        </b-badge>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="col-3 text-nowrap">
                                                        <p class="text-muted font-weight-bold font-size-16 my-0">{{ $t('module.productSource') }}</p>
                                                    </td>
                                                    <td class="text-nowrap">
                                                        <b-badge
                                                            v-for="(item, index) of data.productSource"
                                                            :key="index"
                                                            variant="info"
                                                            class="ml-1"
                                                        >
                                                            <p class="font-size-15 my-0">{{ item }}</p>
                                                        </b-badge>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="col-3 text-nowrap">
                                                        <p class="text-muted font-weight-bold font-size-16 my-0">{{ $t('module.recommendation') }}</p>
                                                    </td>
                                                    <td class="py-0 px-0 my-0">
                                                        <table class="table-bordered border-light">
                                                            <tbody>
                                                                <tr
                                                                    v-for="(item, index) of data.productRecommendation"
                                                                    :key="index"
                                                                    class=""
                                                                >
                                                                    <td>
                                                                        <p class="font-size-15 my-0">{{ item.remark }}</p>
                                                                    </td>
                                                                    <td class=" px-0 mx-0 py-0 my-0">
                                                                        <table class="table-bordered border-light">
                                                                            <tbody>
                                                                                <tr
                                                                                    v-for="(crop, cr) of item.crops"
                                                                                    :key="cr"
                                                                                >
                                                                                    <td class="col-6">
                                                                                        <b-badge variant="info">
                                                                                            <p class="font-size-15 my-0">{{ crop.name }}</p>
                                                                                        </b-badge>
                                                                                    </td>
                                                                                    <td class="text-nowrap">
                                                                                        <b-badge
                                                                                            v-for="(pest, p) of crop.pest_controls"
                                                                                            :key="p"
                                                                                            class="mr-1"
                                                                                            variant="primary"
                                                                                        >
                                                                                            <p class="font-size-15 my-0">{{ pest.pest_control }}  {{ `(${pest.rate})` }}</p>
                                                                                        </b-badge>
                                                                                    </td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="col-3 text-nowrap">
                                                        <p class="text-muted font-weight-bold font-size-16 my-0">{{ $t('module.productMoa') }}</p>
                                                    </td>
                                                    <td class="text-nowrap">
                                                        <b-badge
                                                            v-for="(item, index) of data.rndProductMoa"
                                                            :key="index"
                                                            variant="info"
                                                            class="ml-1"
                                                        >
                                                            <p class="font-size-15 my-0">{{ item }}</p>
                                                        </b-badge>
                                                    </td>
                                                </tr>
                                                <!-- <tr>
                                                    <td class="col-3 text-nowrap">
                                                        <p class="text-muted font-weight-bold font-size-16 my-0">{{ $t('module.productLabel') }}</p>
                                                    </td>
                                                    <td class="px-0 py-0 text-nowrap">
                                                        <table class="table-bordered border-light my-0 py-0">
                                                            <tbody>
                                                                <tr
                                                                    v-for="(item, index) of data.productLabel"
                                                                    :key="index"
                                                                    class="my-0 py-0"
                                                                >
                                                                    <td class="py-0 my-0 col-auto">
                                                                        <b-badge variant="light">
                                                                            <p class="font-size-16 my-0">{{ item.date }}</p>
                                                                        </b-badge>
                                                                    </td>
                                                                    <td class="py-0 my-0 pl-3 col-auto">
                                                                        <b-badge variant="info">
                                                                            <p class="font-size-16 my-0">{{ item.packaging_material }}</p>
                                                                        </b-badge>
                                                                    </td>
                                                                    <td class="py-0 my-0 col-auto">
                                                                        <b-badge
                                                                            v-for="(size, sIndex) of item.sizes"
                                                                            :key="sIndex"
                                                                            variant="primary"
                                                                            class="ml-1"
                                                                        >
                                                                            <p class="font-size-16 my-0">{{ size }}</p>
                                                                        </b-badge>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr> -->
                                                <tr>
                                                    <td class="col-3 text-nowrap">
                                                        <p class="text-muted font-weight-bold font-size-16 my-0">{{ $t('module.productLabel') }}</p>
                                                    </td>
                                                    <td class="px-0 py-0 text-nowrap">
                                                        <table class="table-bordered border-light my-0 py-0">
                                                            <tbody>
                                                                <tr
                                                                    v-for="(item, index) of data.rndProductNewLabels"
                                                                    :key="index"
                                                                    class="my-0 py-0 d-flex"
                                                                >
                                                                    <td class="py-0 my-0 col-auto">
                                                                        <b-badge variant="light">
                                                                            <p class="font-size-16 my-0">{{ item.date }}</p>
                                                                        </b-badge>
                                                                    </td>
                                                                    <div
                                                                        v-for="(i, j) in item?.labels"
                                                                        :key="j"
                                                                        class="font-size-14 text-muted text-nowrap border border-secondary rounded px-2 mb-1 mr-1"
                                                                    >
                                                                        <div>
                                                                            <span class="font-weight-bold">{{ $t('label.packagingMaterial') }}:</span>
                                                                            {{ i?.packagingMaterial || '--' }}
                                                                        </div>
                                                                        <div>
                                                                            <span class="font-weight-bold">{{ $t('label.xSize', []) }}:</span>
                                                                            {{ i?.size || '--' }}
                                                                        </div>
                                                                        <div>
                                                                            <span class="font-weight-bold">{{ $t('label.remark') }}:</span>
                                                                            {{ i?.remark || '--' }}
                                                                        </div>
                                                                        <div v-if="i.images.length > 0">
                                                                            <span class="font-weight-bold">{{ $t('label.image') }} ({{ i.images.length }}): </span>
                                                                            <b-badge
                                                                                variant="primary cursor-pointer"
                                                                                v-on:click="$bvModal.show('product_labels_image_modal_'+i.uuid)"
                                                                            >
                                                                                {{ $t('label.viewX', []) }}
                                                                            </b-badge>
                                                                            <b-modal
                                                                                :id="'product_labels_image_modal_'+i.uuid"
                                                                                :title="$t('label.image')"
                                                                                size="lg"
                                                                                centered
                                                                                hide-header-close
                                                                            >
                                                                                <div class="row">
                                                                                    <div v-for="(img, imgIndex) in i.images" :key="imgIndex" class="col-4 mb-2">
                                                                                        <a :href="img.imageUrl" target="_blank" class="cursor-pointer">
                                                                                            <img
                                                                                                :src="img.imageUrl"
                                                                                                class="img-thumbnail img-fluid"
                                                                                                style="width: 100%; aspect-ratio: 1 / 1; object-fit: cover; border-radius: 4px;"
                                                                                                :title="$t('label.viewX', [])"
                                                                                            >
                                                                                        </a>
                                                                                    </div>
                                                                                </div>
                                                                                <template #modal-footer>
                                                                                    <b-button variant="secondary" v-on:click="$bvModal.hide('product_labels_image_modal_'+u.uuid)">
                                                                                        {{ $t('label.cancel') }}
                                                                                    </b-button>
                                                                                </template>
                                                                            </b-modal>
                                                                        </div>
                                                                    </div>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="col-3 text-nowrap">
                                                        <p class="text-muted font-weight-bold font-size-16 my-0">{{ $t('label.remark') }}</p>
                                                    </td>
                                                    <td class="text-nowrap">
                                                        <p class="font-size-16 my-0">{{ data.remark }}</p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-card-body>
                    </b-card>
                </b-container>
            </b-row>
        </b-col>
    </div>
</template>

<script>
import { filtersHelper } from '@/utils'
import i18n from "@/i18n";

export default {
    props: {
        tableRows: {
            type: Array,
            required: false,
        },
        updateStatusPermission: {
            type: Boolean,
            required: true,
        },
        readPermission: {
            type: Boolean,
            required: true,
        },
        updatePermission: {
            type: Boolean,
            required: true,
        },
        currentUser: {
            type: String,
            required: true,
        },
    },
    data() {
        return {

        };
    },
    methods: {
        formatData(info) {
            return {
                uuid: info.uuid,
                name: info.name || '--',
                expiredDate: info.expiredDate,
                status: info.status,
                brand: info.brand.name || '--',
                form: info.form.name || '--',
                type: info.type.name || '--',
                class: info.class?.name || '--',
                referenceNumber: info.referenceNumber,
                lrmp: info?.lrmp || '--',
                dor: info.dor || '--',
                dossierSubmissionDate: info.dossierSubmissionDate || '--',
                approvalDate: info.approvalDate || '--',
                purpose: info.purpose?.name || '--',
                productAI: info.productAI.map(item => (item?.rnd_active_ingredient?.name)),
                // productRecommendation: info.productRecommendation.map(item => (item?.remark)),
                productRecommendation: info.productRecommendation,
                productSource: info.productSource.map(item => (item?.source?.name)),
                rndProductMoa: info.rndProductMoa.map(item => (item?.moa?.name)),
                endorseLabelArray: info.endorseLabelArray,
                remark: info.remark || '--',
                isRegisterCert: info.isRegisterCert ? i18n.t('label.yes') : i18n.t('label.no'),
                shelfLifeTime: info.shelfLifeTime || '--',
                isActive: info.isActive,
                // productLabel: info.productLabel.map(item => {
                //     return {
                //         ...item,
                //         date: filtersHelper.getDateFormat(item.date),
                //     };
                // }),
                rndProductNewLabels: info.rndProductNewLabels,
                productQuery: info.productQuery.length > 0 ? filtersHelper.getDateFormat(info.productQuery[info.productQuery.length-1].date) : '--',
                productPayment: info.productPayment.length > 0 ? filtersHelper.getDateFormat(info.productPayment[info.productPayment.length-1].date) : '--',
                productPrinterProof: info.productPrinterProof.length > 0 ? filtersHelper.getDateFormat(info.productPrinterProof[info.productPrinterProof.length-1].date) : '--',
            };
        },
        getVariant(expiredDate) {
            if (!expiredDate) return 'secondary'; // fallback if date is missing

            const today = new Date();
            const expiry = new Date(expiredDate);
            const diffTime = expiry - today;
            const diffDays = diffTime / (1000 * 60 * 60 * 24);

            if (diffDays < 0) {
                return 'danger'; // expired
            } else if (diffDays <= 183) { // ~6 months
                return 'yellow'; // expiring within 6 months
            } else {
                return 'primary'; // valid
            }
        },
        editStatus(data) {
            this.$emit("editStatus", data);
        },
        toReportDetailsPage(data) {
            this.$emit("toReportDetailsPage", data);
        },
        toDetailsPage(data) {
            this.$emit("toDetailsPage", data);
        },
    },
    computed: {
        tableData() {
            return this.tableRows.map(item => this.formatData(item)) || [];
        },
    },
};
</script>

<style>
.dropdown-left .dropdown-menu {
    left: auto !important; /* Reset the default position */
    right: 0 !important;   /* Position to the left of the button */
}
</style>

<style scoped>
a.disabled {
    pointer-events: none;
    cursor: default;
}

.badge-yellow {
    background-color: goldenrod;
    color: #fff;
}
</style>